import { render, staticRenderFns } from "./ListOfCategories.vue?vue&type=template&id=1eb6a6ca"
import script from "./ListOfCategories.vue?vue&type=script&lang=js"
export * from "./ListOfCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports